<template>
  <v-list-item
      :class="(selected ? 'v-list-item--active' : '')+(chat.blink===true ? ' blinkWarning' : '')"
      class="pa-0"
      @click="$emit('click')"
  >
    <v-row class="full-width" no-gutters>
      <v-col class="pa-3">
        <v-row no-gutters>
          <v-col>{{ chat._name }}</v-col>
          <v-col class="caption" cols="auto">
            <v-sheet
                :color="slaColor"
                :class="slaColor ? 'white--text' : ''"
                class="px-1 caption"
                rounded
            >
              {{ $tools.dateFormat(chat.dialogMesLast?.created || chat.created, true) }}
            </v-sheet>
          </v-col>
        </v-row>
        <v-row align="center" no-gutters>
          <v-col class="body-2 text-no-wrap overflow-hidden text-overflow muted1" style="flex:1">
            <span v-if="chat.dialogMesLast===null" class="body-2 text-no-wrap overflow-hidden muted">
              Нет сообщений
            </span>
            <span v-else>
              <span v-if="chat.dialogMesLast.type==='event'" class="muted1">
                {{ chat.dialogMesLast.text }}
              </span>
              <span v-if="chat.dialogMesLast.type==='message'">
                <span>{{ chat.dialogMesLast.dialogUser.name }}:</span>
                <span style="flex:1">{{ chat.dialogMesLast.text }}</span>
                <span v-if="chat.dialogMesLast.dialogMessageAttachs.length>0">(Вложение)</span>
              </span>
            </span>
          </v-col>
          <v-col v-if="chat.muted" class="pl-1" cols="auto">
            <v-sheet color="transparent" height="20" width="20">
              <v-avatar class="caption white--text position-absolute" color="grey" size="20">
                <v-icon small color="white">mdi-bell-off-outline</v-icon>
              </v-avatar>
            </v-sheet>
          </v-col>
          <v-col class="pl-1" cols="auto">
            <v-sheet v-if="chat._unreadCount>0" color="transparent" height="20" width="20">
              <v-avatar class="caption white--text position-absolute" color="primary" size="20">
                {{ chat._unreadCount }}
              </v-avatar>
            </v-sheet>
          </v-col>
        </v-row>
        <v-row no-gutters>
          <v-col v-if="operator!==null" cols="auto" class="mr-2">
            <chip class="mt-1" small>
              <v-row no-gutters align="center">
                <v-col cols="auto">
                  <v-icon class="mr-1" style="margin-top:-2px" small>mdi-account-tie</v-icon>
                </v-col>
                <v-col>{{ $tools.userFullName(operator, true) }}</v-col>
              </v-row>
            </chip>
          </v-col>
          <v-col v-if="chat.cat!=='internal'" cols="auto">
            <chip class="mt-1" small>
              <v-row no-gutters class="text-left">
                <v-col cols="auto">
                  <v-icon class="mr-1" style="margin-top:-2px" small>mdi-account-badge</v-icon>
                </v-col>
                <v-col>
                  <div v-if="chat.callTarget==null">Не указана цель обращения</div>
                  <div v-else>
                    {{ chat.callTarget.name }}
                    <div v-if="chat.callResult!==null" class="d-inline-block">
                      <dot/>
                      <v-avatar v-if="chat.callResult.type==='success'" color="success" size="12" class="mr-1"
                                style="margin-top:-2px">
                        <v-icon color="white" size="10">mdi-check</v-icon>
                      </v-avatar>
                      <v-avatar v-else-if="chat.callResult.type==='info'" color="blue" size="12" class="mr-1"
                                style="margin-top:-2px">
                        <v-icon color="white" size="14">mdi-information-symbol</v-icon>
                      </v-avatar>
                      <v-avatar v-else color="red" size="12" class="mr-1" style="margin-top:-2px">
                        <v-icon color="white" size="8">mdi-close</v-icon>
                      </v-avatar>
                      {{ chat.callResult.name }}
                    </div>
                  </div>
                </v-col>
              </v-row>
            </chip>
          </v-col>
        </v-row>
      </v-col>
      <v-col cols="12">
        <v-divider/>
      </v-col>
    </v-row>
  </v-list-item>
</template>

<script>
import Chip from "@/componentsV2/base/Chip.vue";
import Dot from "../../../../componentsV2/base/Dot.vue";

export default {
  components: {Dot, Chip},
  props: {
    chat: {},
    selected: {type: Boolean, default: false},
    cat: {},
    filterView: {},
    slaTick: {default: 0},
  },
  computed: {
    slaColor() {
      void this.slaTick;
      const catId = this.cat?.id || this.chat.cat;
      if (catId !== 'queue' && catId !== 'process') {
        return '';
      }
      const last = this.chat.dialogMesLast;
      if (!last?.dialogUser || last.dialogUser.provider === 'internal') {
        return '';
      }
      const created = last.created;
      if (!created) {
        return '';
      }
      const t = Date.parse(String(created).replace(' ', 'T'));
      if (Number.isNaN(t)) {
        return '';
      }
      const minutes = (Date.now() - t) / 60000;
      if (minutes > 60) return 'error';
      if (minutes > 15) return 'warning';
      return '';
    },
    operator() {
      if (this.cat?.id === 'internal') return null;
      if (this.filterView?.id !== 'all') return null;
      let arr = (this.chat.dialogUsers || []).filter(v => v.user?.type !== 'client')
      if (arr.length > 0) return arr[0].user;
      return null;
    },
  },
}
</script>
